import { render, staticRenderFns } from "./ModaFormIncreasesComponent.vue?vue&type=template&id=a0670b58"
import script from "./ModaFormIncreasesComponent.vue?vue&type=script&lang=js"
export * from "./ModaFormIncreasesComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModaFormIncreasesComponent.vue?vue&type=style&index=1&id=a0670b58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports